import * as React from 'react';
import { VideoRef } from '../../../../commonv3/types/block';
import './blockVideo.module.scss';

export function getYoutubeVideoId(url: string): string | null {
  const shortLinkMatch = url.match('https?://youtu\\.be/([a-zA-Z0-9_-]+)');
  if (shortLinkMatch) {
    return shortLinkMatch[1];
  }
  const embedMatch = url.match('https?://www\\.youtube\\.com/embed/([a-zA-Z0-9_-]+)');
  if (embedMatch) {
    return embedMatch[1];
  }
  const normalUrlMatch = url.match('(&|\\?)v=([a-zA-Z0-9_-]+)');
  if (normalUrlMatch) {
    return normalUrlMatch[2];
  }
  return null;
}

type Props = {
  videoRef: VideoRef;
};

export class BlockVideo extends React.Component<Props> {
  render() {
    const {
      videoRef: { provider, url },
    } = this.props;
    try {
      const url1 = new URL(url);
      const pathname = url1.pathname;
      if (provider === 'vimeo') {
        const videoId = pathname.match(/.*\/(\d+)(\/)?$/)?.[1];
        return (
          <div styleName="video-wrapper">
            <iframe
              src={`https://player.vimeo.com/video/${videoId}`}
              frameBorder="0"
              allow="autoplay; fullscreen"
              allowFullScreen
            />
          </div>
        );
      }
      if (provider === 'youtube') {
        return (
          <div styleName="video-wrapper">
            <iframe
              src={`https://www.youtube.com/embed/${getYoutubeVideoId(url)}?origin=${location.origin}`}
              frameBorder="0"
              allow="autoplay; fullscreen"
              allowFullScreen
            />
          </div>
        );
      }
    } catch {
      return null;
    }
  }
}
